/* eslint-disable */
/// This file is auto generated - do not edit manually
export const AdvisorRecommendsTitle = 'Website.ProductRegime.AdvisorRecommendsTitle';
export const AdvisorRecommends = 'Website.ProductRegime.AdvisorRecommends';
export const SoldOutOnline = 'Website.ProductRegime.SoldOutOnline';
export const AddOneToBasket = 'Website.ProductRegime.AddOneToBasket';
export const AddMultipleToBasket = 'Website.ProductRegime.AddMultipleToBasket';
export const PriceTotal = 'Website.ProductRegime.PriceTotal';
export const NoProductsSelected = 'Website.ProductRegime.NoProductsSelected';
export const RegimeHeaderCount = 'Website.ProductRegime.RegimeHeaderCount';
export const SeeMore = 'Website.ProductRegime.SeeMore';
export const SeeLess = 'Website.ProductRegime.SeeLess';
export const CurrentProduct = 'Website.ProductRegime.CurrentProduct';
export const AdvisorRecommendsTitleSimple = 'Website.ProductRegime.AdvisorRecommendsTitleSimple';
export const AdvisorRecommendsOverlineSimple = 'Website.ProductRegime.AdvisorRecommendsOverlineSimple';
export const AdvisorRecommendsTextSimple = 'Website.ProductRegime.AdvisorRecommendsTextSimple';
